import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyBitcoinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_bitcoin"}/>
}
